import { REMOTE_MCP_PRO_OFFER, type UpgradeSurface } from "../../../utils/conversion-shared";
import type { ConversionContext } from "../contexts/UsageContext";
import type { UpgradeAccountCheck } from "./accountCheck";
import { trackEvent } from "./browserAnalytics";

type TrackUpgradeClickedOptions = {
    surface: UpgradeSurface;
    conversionContext: ConversionContext | null;
    fallbackPlan: "free" | "pro";
};

export function trackUpgradeClicked({ surface, conversionContext, fallbackPlan }: TrackUpgradeClickedOptions) {
    return trackEvent("upgrade_clicked", {
        ...(conversionContext ?? {}),
        plan: conversionContext?.plan ?? fallbackPlan,
        surface,
        price_shown: REMOTE_MCP_PRO_OFFER.priceShown,
        currency: REMOTE_MCP_PRO_OFFER.currency,
        billing_period: REMOTE_MCP_PRO_OFFER.billingPeriod,
    });
}

type TrackUpgradeAccountCheckOptions = {
    surface: UpgradeSurface;
    conversionContext: ConversionContext | null;
    check: UpgradeAccountCheck;
};

/**
 * The "Is this the right account?" dialog before checkout: shown, then either upgraded (checkout
 * opens and upgrade_clicked fires as usual) or switched (signed out to use another account).
 */
export function trackUpgradeAccountCheck(
    action: "shown" | "upgraded" | "switched",
    { surface, conversionContext, check }: TrackUpgradeAccountCheckOptions,
) {
    return trackEvent(`upgrade_account_check_${action}`, {
        ...(conversionContext ?? {}),
        surface,
        no_devices: check.noDevices,
        no_calls: check.noCalls,
    });
}
